module.exports = __webpack_public_path__ + "img/4.b673d82d.png";